var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 16.6667C4.375 16.3215 4.65482 16.0417 5 16.0417L15 16.0417C15.3452 16.0417 15.625 16.3215 15.625 16.6667C15.625 17.0119 15.3452 17.2917 15 17.2917L5 17.2917C4.65482 17.2917 4.375 17.0119 4.375 16.6667Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55806 13.7753C9.80214 14.0194 10.1979 14.0194 10.4419 13.7753L13.3586 10.8586C13.6027 10.6145 13.6027 10.2188 13.3586 9.97473C13.1145 9.73066 12.7188 9.73066 12.4747 9.97473L10.625 11.8245V3.33334C10.625 2.98817 10.3452 2.70834 10 2.70834C9.65482 2.70834 9.375 2.98817 9.375 3.33334V11.8245L7.52527 9.97473C7.2812 9.73066 6.88547 9.73066 6.64139 9.97473C6.39731 10.2188 6.39731 10.6145 6.64139 10.8586L9.55806 13.7753Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6432c44ff3984639489913d739cde910.svg";
export { ForwardRef as ReactComponent };